import React from 'react'
import { Box, Container } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { PasswordResetForm } from '../components/auth/PasswordResetForm'

const PasswordResetPage: React.FC = () => {
  const navigate = useNavigate()

  const handleBack = () => {
    navigate('/login')
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <PasswordResetForm onBack={handleBack} />
      </Box>
    </Container>
  )
}

export default PasswordResetPage
